import { getName } from 'country-list';

import { parseRatingType } from 'shared/parsers';

export const parseIndustryEntities = entities =>
  entities.map(({ id, name, countryCode, longTermRating, shortTermRating, ratingType }) => [
    [id, name],
    getName(countryCode),
    ratingType ? parseRatingType(ratingType) : '-',
    longTermRating ? longTermRating.rating : '-',
    shortTermRating ? shortTermRating.rating : '-',
  ]);
